import { useRef, useState } from 'react';
import useEditorialMotion from '@/hooks/useEditorialMotion';
import { Link } from 'react-router-dom';
import { careFaq } from '@/mocks/editorial';

export default function CareFaq() {
  const [open, setOpen] = useState<string | null>(null);
  const ref = useRef<HTMLElement>(null);
  useEditorialMotion(ref);
  return (
    <section ref={ref} aria-labelledby="care-title" className="bg-[#FAFAF8] px-4 md:px-10 py-16 md:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-8 lg:gap-16">
        <div>
          <p data-m-fade className="text-[11px] md:text-[12px] tracking-wide text-black/50 mb-4">DELIVERY &amp; CARE</p>
          <h2 data-m-head id="care-title" className="font-normal tracking-[-0.04em] leading-none text-[32px] md:text-[48px]">Good to know.</h2>
        </div>
        <div className="border-t border-black/15">
          {careFaq.map((item) => {
            const isOpen = open === item.id;
            return (
              <div key={item.id} className="border-b border-black/15">
                <h3>
                  <button
                    type="button"
                    id={`faq-btn-${item.id}`}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${item.id}`}
                    onClick={() => setOpen(isOpen ? null : item.id)}
                    className="w-full flex items-center justify-between gap-4 py-5 text-left text-[16px] md:text-[18px] tracking-[-0.015em] cursor-pointer"
                  >
                    {item.q}
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 text-black/50"><i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i></span>
                  </button>
                </h3>
                <div id={`faq-panel-${item.id}`} role="region" aria-labelledby={`faq-btn-${item.id}`} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <p className="pb-6 text-[14px] leading-relaxed text-black/65 max-w-[620px]">
                      {item.a}
                      {item.id === 'custom' && (
                        <>
                          {' '}
                          <Link to="/#bespoke" tabIndex={isOpen ? 0 : -1} className="border-b border-black/30 hover:border-black text-black whitespace-nowrap cursor-pointer">Start a bespoke enquiry →</Link>
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}